/* eslint-disable max-len */
import React from 'react'
import { useNavigate,useLocation, useSearchParams } from 'react-router-dom'
import AnimatedList from '../../../../../components/Animation/AnimatedList'
import { useSelector } from 'react-redux'

const OrgPatientTableBody=({
    tableData,
    indexNum,
    setTableViewData
})=>{
    const navigate=useNavigate()
    const location=useLocation()
    const auth=useSelector(state=>state?.auth)
    const [searchParams,setSearchParams] = useSearchParams()

    const handlePatientView = () =>{
        let params = Object.fromEntries(searchParams);
        params['view'] = tableData?._id
        setSearchParams({ ...params})
        setTableViewData(tableData)
    }

    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={()=>{
                    handlePatientView()
                }}
                child={
                    <>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.patient_id}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {tableData?.first_name}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {tableData?.middle_name===""?'-':tableData?.middle_name}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.last_name}</td>
                        <td className="px-[18px] py-2">
                            <div className="flex items-center justify-start">
                                <img loading="lazy" decoding="async" src={`${tableData?.status==="active"?"/images/active_list_img.svg":'/images/inactive_list_img.svg'}`} alt="icon" />
                                <span className="text-sm text-start font-normal text-[#031624] pl-2">{tableData?.status==="active"?"Active":"Inactive"}</span>
                            </div>
                        </td>                        
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-sm rounded-bl-sm flex justify-center">
                            <button
                                onClick={()=>{handlePatientView()}}
                                className='border border-[#972E4C] rounded-md text-[#972E4C] text-[15px] py-1.5 px-4 leading-[12px]'>
                                View
                            </button>
                        </td>
                    </>
                    
                }/>
           
        </>
    )
}

export default OrgPatientTableBody